import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderDeliveryButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a href={`https://www.doordash.com/store/23529831`}>
              <CFView hover>
                <CFImage
                  src={orderDeliveryButton}
                  w="95%"
                  maxWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a href={`https://www.doordash.com/store/23529831`}>
              <CFView hover>
                <CFImage
                  src={orderDeliveryButton}
                  w="25vw"
                  maxWidth="280px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
